import { Box, Typography } from '@mui/material';

import { CampaignsProgressBarLabelProps } from '../campaign-cars-execution-progress-bar/models/campaigns-progress-bar-label.props';

export const CampaignsProgressBarLabel = ({
  labelText,
}: CampaignsProgressBarLabelProps): JSX.Element => {
  return (
    <Box>
      <Typography>{labelText}</Typography>
    </Box>
  );
};
